import React from 'react';

import PropTypes from 'prop-types';

import { useProjectsAnalyticsFilterSelectionConfigurationQuery as useFilterSelectionConfigurationQuery } from 'components/hooks/projectsAnalyticsFilterSelectionConfigurationQueries';

import { useProjectsAnalyticsDashboardContext } from 'components/contexts/ProjectsAnalyticsDashboardContext';
import Grid from 'components/projectsAnalytics/components/Grid';
import ProjectsAnalyticsDashboardView from 'components/projectsAnalytics/components/ProjectsAnalyticsDashboardView';

export default function ProjectsAnalyticsDashboard() {
  const {
    divisionsTotalCount,
    isApprovalsEnabled,
    isDigitalSignaturesEnabled,
    seedFilterSelectionConfiguration,
  } = useProjectsAnalyticsDashboardContext();

  // window.performance is the most relaible way to detect browser navigation events
  const isReloadOrBackForwardBrowserNavigationEvent = [
    'reload',
    'back_forward',
  ].includes(window.performance.getEntriesByType('navigation')[0].type);

  // only able to reliably detect this browser navigation event from FE, so
  // doing what the BE would have done if this check had been done there instead
  const initialData =
    isReloadOrBackForwardBrowserNavigationEvent ?
      { data: null, meta: { isBulkUpdateInProgress: true } }
    : seedFilterSelectionConfiguration;

  const { data: domainFilterSelectionConfiguration } =
    useFilterSelectionConfigurationQuery({ queryOptions: { initialData } });

  const isFilterable = divisionsTotalCount > 1;

  return domainFilterSelectionConfiguration.meta.isBulkUpdateInProgress ?
      <Skeleton
        cardsLength={
          3 +
          (isApprovalsEnabled ? 1 : 0) +
          (isDigitalSignaturesEnabled ? 1 : 0)
        }
        isFilterable={isFilterable}
      />
    : <ProjectsAnalyticsDashboardView
        domainFilterSelectionConfiguration={domainFilterSelectionConfiguration}
        isFilterable={isFilterable}
      />;
}

function Skeleton({ cardsLength, isFilterable }) {
  return (
    <>
      {isFilterable && (
        <div className='tw-flex tw-justify-center tw-pb-6'>
          <div className='tw-flex tw-w-full tw-max-w-[1164px] tw-items-center tw-gap-3'>
            <div className='tw-flex-1'>
              <div className='tw-h-8 tw-w-32 tw-animate-pulse tw-rounded-lg tw-bg-grey-100' />
            </div>
            <div className='tw-flex tw-justify-end'>
              <div className='tw-h-8 tw-w-25 tw-animate-pulse tw-rounded-lg tw-bg-grey-100' />
            </div>
          </div>
        </div>
      )}
      <Grid>
        {Array.from({ length: cardsLength }, (_, i) => (
          <div
            className='tw-h-80 tw-animate-pulse tw-rounded-lg tw-bg-grey-100'
            key={i}
          />
        ))}
      </Grid>
    </>
  );
}

Skeleton.propTypes = {
  cardsLength: PropTypes.number.isRequired,
  isFilterable: PropTypes.bool.isRequired,
};
